"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(props) {
  var theme = props.theme;
  var error = props.error,
      disabled = props.disabled,
      readOnly = props.readOnly,
      hover = props.hover,
      active = props.active,
      _theme = theme,
      palette = _theme.palette;
  theme = _objectSpread({}, theme, {
    borderColor: theme.idleBorderColor,
    borderStyle: theme.idleBorderStyle,
    borderWidth: theme.idleBorderWidth,
    borderTransform: theme.idleBorderTransform
  });

  if (hover) {
    theme = _objectSpread({}, theme, {
      borderColor: theme.hoverBorderColor,
      borderStyle: theme.hoverBorderStyle,
      borderWidth: theme.hoverBorderWidth,
      borderTransform: theme.hoverBorderTransform
    });
  }

  if (active) {
    theme = _objectSpread({}, theme, {
      borderColor: theme.focusBorderColor,
      borderStyle: theme.focusBorderStyle,
      borderWidth: theme.focusBorderWidth,
      borderTransform: theme.focusBorderTransform
    });
  }

  if (error) {
    theme = _objectSpread({}, theme, {
      borderColor: theme.errorBorderColor,
      borderStyle: theme.errorBorderStyle,
      borderWidth: theme.errorBorderWidth,
      borderTransform: theme.errorBorderTransform
    });
  }

  if (disabled || readOnly) {
    theme = _objectSpread({}, theme, {
      borderStyle: theme.disabledBorderStyle,
      borderColor: theme.disabledBorderColor,
      borderWidth: theme.disabledBorderWidth,
      borderTransform: theme.disabledBorderTransform
    });
  } // рамка со всех сторон, классический инпут
  // скрываем нижнюю границу, применяем стиль к инпуту напрямую


  var noBorder = !/none/.test(theme.borderStyle) || theme.borderStyle === 'none';
  return {
    passive: {
      borderImage: 'none',
      borderStyle: 'none none solid',
      boxSizing: 'content-box',
      height: 0,
      margin: 0,
      position: 'absolute',
      bottom: 0,
      width: '100%',
      borderColor: theme.idleBorderColor,
      borderWidth: "medium medium ".concat(theme.idleBorderWidth),
      display: noBorder ? 'none' : 'block'
    },
    active: {
      borderWidth: "medium medium ".concat(theme.borderWidth),
      borderImage: 'none',
      borderStyle: theme.borderStyle,
      boxSizing: 'content-box',
      height: 0,
      margin: 0,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: 'ease',
      transitionProperty: 'transform, border-color',
      position: 'absolute',
      bottom: 0,
      width: '100%',
      borderColor: theme.borderColor,
      transform: theme.borderTransform,
      display: noBorder ? 'none' : 'block'
    }
  };
}